export enum ResizeDirection {
  horizontal = 'horizontal',
  /** Component can only be resized vertically */
  vertical = 'vertical',
  /** Component can be resized both horizontally and vertically */
  horizontalAndVertical = 'horizontalAndVertical',
  /** Component maintains its aspect ratio while resizing */
  aspectRatio = 'aspectRatio',
  /** Component cannot be resized in any direction */
  none = 'none',
}

export enum ContentResizeDirection {
  /** Component's width will automatically adjust based on its content */
  horizontal = 'horizontal',
  /** Component's height will automatically adjust based on its content */
  vertical = 'vertical',
  /** Component's width and height will automatically adjust based on its content */
  horizontalAndVertical = 'horizontalAndVertical',
  /** Component's size will not be affected by its content */
  none = 'none',
}

/**
 * Resize direction options available for OOI widgets.
 * Excludes aspectRatio as it's not supported for OOI components.
 */
export type OOIResizeDirection = Exclude<
  ResizeDirection,
  ResizeDirection.aspectRatio
>;

export interface EditorElementLayout {
  /** The resizing capabilities this component can supports */
  resizeDirection?: ResizeDirection;
  /** Describes the ability of content to impact on the size of this component */
  contentResizeDirection?: ContentResizeDirection;
  /** Will control the availability of the stretch capability for this component */
  disableStretching?: boolean;
  /** Will control the availability of freely positioning this component */
  disablePositioning?: boolean;
  /** Will control if the editor allows rotating the element */
  disableRotation?: boolean;
}
